import { render, staticRenderFns } from "./VSelectVacuna.vue?vue&type=template&id=72322562&scoped=true"
import script from "./VSelectVacuna.vue?vue&type=script&lang=js"
export * from "./VSelectVacuna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72322562",
  null
  
)

export default component.exports